import React, { forwardRef } from 'react';

const InputField = forwardRef(({ 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  id,
  name,
  autoComplete,
  className = "",
  onFocus,
  onBlur,
  ...props
}, ref) => {
  return (
    <input 
      ref={ref}
      type={type}
      placeholder={placeholder}
      className={`w-full bg-transparent border-b border-gray-600 text-white py-2 placeholder-gray-400 focus:outline-none focus:border-[#61EA3C] ${className}`}
      id={id}
      name={name}
      style={{
        '--tw-border-opacity': '1',
        borderColor: 'rgb(255 255 255 / 30%)',
      }}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete={autoComplete}
      {...props}
    />
  );
});

InputField.displayName = 'InputField';

export default InputField;